export const DRAFT_STATUS = [
	{ value: 'all', label: 'All'},
    { value: 'pending', label: 'Draft' },
    { value: 'rejected', label: 'Rejected' },
]